import React from 'react'
import { Box, Icon } from '@mui/material'
import AdxToolTip from 'components/custom/AdxToolTip'
import AdxButton from 'components/custom/AdxButton'

const FloatActBtn = ({
  handleFloatAddQuestion,
  handleFloatAddSection,
  handleSectMove,
  sectionLength,
  sectIndex,
  quesIndex,

  isSection,
  isHeader,
}) => {
  const hoverProp = () => {
    return {
      width: 45,
      minWidth: 45,
      height: 45,
      backgroundColor: 'white.main',
      color: 'alternate.main',
      '&:hover': {
        color: 'white.main',
        backgroundColor: 'alternate.main',
      },
    }
  }

  return (
    <Box display="flex" flexDirection="column" position="absolute" right={-55} gap={0.8}>
      {isSection && sectIndex !== 0 && !isHeader ? (
        <AdxToolTip title="Move section up" placement="right">
          <Box>
            <AdxButton
              variant={'contained'}
              sx={{ ...hoverProp() }}
              onClick={() => handleSectMove('up', sectIndex)}
            >
              <Icon>keyboard_arrow_up_icon</Icon>
            </AdxButton>
          </Box>
        </AdxToolTip>
      ) : null}
      {isSection && sectIndex + 1 !== sectionLength && !isHeader ? (
        <AdxToolTip title="Move section down" placement="right">
          <Box>
            <AdxButton
              variant={'contained'}
              sx={{ ...hoverProp() }}
              onClick={() => handleSectMove('down', sectIndex)}
            >
              <Icon>keyboard_arrow_down_icon</Icon>
            </AdxButton>
          </Box>
        </AdxToolTip>
      ) : null}
      <AdxToolTip title="Add section" placement="right">
        <Box>
          <AdxButton
            variant={'contained'}
            sx={{ ...hoverProp() }}
            onClick={() => handleFloatAddSection(sectIndex, quesIndex)}
          >
            <Icon>splitscreen_outlined_icon</Icon>
          </AdxButton>
        </Box>
      </AdxToolTip>
      <AdxToolTip title="Add question" placement="right">
        <Box>
          <AdxButton
            variant={'contained'}
            sx={{ ...hoverProp() }}
            onClick={() => handleFloatAddQuestion(sectIndex, quesIndex)}
          >
            <Icon>add_comment_icon</Icon>
          </AdxButton>
        </Box>
      </AdxToolTip>
    </Box>
  )
}

export default FloatActBtn
